import useCollection from 'core/hooks/useCollection'

const useContacts = (...args) => useCollection('contacts', ...args)
export default useContacts
